export const clean_DiseaseProfile = Object.freeze({
    referenceIds: [],
    chiefComplaintIds: [],
    label: '',
    initials: '',
    backgroundColor: { value: '' },
    color: { value: '' },
    icd: [],
    tagIds: [],
});
/**
 * Canonical Firebase Storage object path of a disease profile's attached HTML. Single source of truth
 * shared by the importer (upload + rollback), edit-mode attach/replace, and DP delete (cleanup), so all
 * derive it from diseaseProfileId. This is only the object name; the bucket is the environment's default.
 */
export const diseaseProfileHtmlStoragePath = (diseaseProfileId) => `assets/disease-profiles-html/${diseaseProfileId}/profile.html`;
//# sourceMappingURL=consts.js.map